declare const __DEV__: boolean | undefined;

export const isDev: boolean = (() => {
  const meta = import.meta as { env?: { DEV?: boolean } } | undefined;
  if (meta?.env?.DEV) return true;
  if (typeof __DEV__ !== 'undefined') return Boolean(__DEV__);
  if (typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production') return true;
  return false;
})();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap<T extends (...args: any[]) => void>(fn: T): T {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return ((...args: any[]) => {
    if (isDev) fn(...args);
  }) as T;
}

// Hermes (Release) omits several console methods. Safe-bind returns a no-op
// for any method that doesn't exist so module-level init never throws.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function bc<T extends (...args: any[]) => void>(fn: T | undefined): T {
  return (fn ? fn.bind(console) : () => {}) as T;
}

export const dev = {
  log: wrap(bc(console.log)),
  warn: wrap(bc(console.warn)),
  error: wrap(bc(console.error)),
  info: wrap(bc(console.info)),
  debug: wrap(bc(console.debug)),
  trace: wrap(bc(console.trace)),
  table: wrap(bc(console.table)),
  dir: wrap(bc(console.dir)),
  dirxml: wrap(bc(console.dirxml)),
  group: wrap(bc(console.group)),
  groupCollapsed: wrap(bc(console.groupCollapsed)),
  groupEnd: wrap(bc(console.groupEnd)),
  count: wrap(bc(console.count)),
  countReset: wrap(bc(console.countReset)),
  time: wrap(bc(console.time)),
  timeEnd: wrap(bc(console.timeEnd)),
  timeLog: wrap(bc(console.timeLog)),
  assert: wrap(bc(console.assert)),
  clear: wrap(bc(console.clear)),
};
